import * as React from "react";

const SvgStar = ({ width, fill, ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={`${width}`}
      viewBox="0 0 16 17"
      fill="none"
    >
      <path
        d="M7.10346 3.64964C7.47029 2.90647 8.53003 2.90647 8.89687 3.64964L9.82772 5.53543C9.97326 5.83028 10.2544 6.03474 10.5798 6.08229L12.663 6.38679C13.483 6.50663 13.8097 7.51448 13.2162 8.09264L11.7103 9.55935C11.4744 9.78909 11.3667 10.1202 11.4224 10.4448L11.7776 12.5156C11.9177 13.3326 11.0602 13.9556 10.3265 13.5698L8.46561 12.5911C8.17423 12.4379 7.82609 12.4379 7.53471 12.5911L5.67379 13.5698C4.94016 13.9556 4.08262 13.3326 4.22274 12.5156L4.57792 10.4448C4.63358 10.1202 4.52591 9.78909 4.29004 9.55935L2.78417 8.09264C2.19058 7.51448 2.51736 6.50663 3.33728 6.38679L5.42053 6.08229C5.74588 6.03474 6.02707 5.83028 6.17261 5.53543L7.10346 3.64964Z"
        fill={`${fill}`}
      />
    </svg>
  );
};
export default SvgStar;
